import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveActivityMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveActivityParam } from 'api/types/params';

import { parseLegalClient, parseLegalClientSaveActivityParam } from './helpers';

export const useLegalClientSaveActivity = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveActivityMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveActivity
      ? parseLegalClient(data.legalClientSaveActivity)
      : undefined,
    loading,
    error,
    saveActivity: useCallback(
      async (id: string, params: LegalClientSaveActivityParam) => {
        const input = parseLegalClientSaveActivityParam(params);
        const res = await handle({
          variables: {
            id,
            input,
          },
        });
        return res?.data?.legalClientSaveActivity
          ? parseLegalClient(res.data.legalClientSaveActivity)
          : undefined;
      },
      [handle]
    ),
  };
};
